<template>
  <div class="left-wrapper">
    <div class="list-tableau-colonne-0">
      <h2  v-b-toggle="'collapse-0'">Client</h2>

      <div>
        <b-collapse :id="'collapse-0'"  class="tab-0" role="tabpanel">
          <div class="panel-collapse">
            <div class="panel-body">
              <p><font-awesome-icon :icon="['fas', 'exclamation-triangle']" /> Les champs ci-dessous apparaissent dans le tableau de surface mais ne sont pas placés dans la fiche d'espaces</p>

              <vue-custom-scrollbar class="scroll-area" :settings="settings">
                <draggable class="list-group" :group="{ name: 'people', pull: 'clone', put: false }" :sort="false" :list="client" group="tableauColonne">
                  <div class="list-group-item" v-for="c in client" :key="c.key" :id="c.key">{{ c.titre }}</div>
                </draggable>
              </vue-custom-scrollbar>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
    <div class="list-tableau-colonne-0">
      <h2 v-b-toggle="'collapse-1'">Projet</h2>

      <b-collapse :id="'collapse-1'"  class="tab-0" role="tabpanel">
        <div class="panel-collapse">
          <div class="panel-body">
            <p><font-awesome-icon :icon="['fas', 'exclamation-triangle']" /> Les champs ci-dessous apparaissent dans le tableau de surface mais ne sont pas placés dans la fiche d'espaces</p>

            <vue-custom-scrollbar class="scroll-area" :settings="settings">
              <draggable class="list-group" :sort="false" :list="projet" group="tableauColonne">
                <div class="list-group-item" v-for="c in projet" :key="c.key" :id="c.key">{{ c.titre }}</div>
              </draggable>
            </vue-custom-scrollbar>
          </div>
        </div>
      </b-collapse>
    </div>
    <div id="list-tableau-colonne">
      <h2 v-b-toggle="'collapse-2'">Champs disponibles</h2>

      <b-collapse :id="'collapse-2'"  class="tab-0" role="tabpanel">
        <div class="panel-collapse">
          <div class="panel-body">
            <p><font-awesome-icon :icon="['fas', 'exclamation-triangle']" /> Les champs ci-dessous apparaissent dans le tableau de surface mais ne sont pas placés dans la fiche d'espaces</p>

            <vue-custom-scrollbar class="scroll-area" :settings="settings">

              <draggable class="list-group" :sort="false" :list="ficheData.listColonne" group="tableauColonne">
                <div
                        class="list-group-item"
                        v-for="(element, index) in ficheData.listColonne"
                        :key="'data-'+element.key+'-'+index"
                >
                  {{ element.titre }}
                </div>
              </draggable>
            </vue-custom-scrollbar>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import {eventBus} from '../../../main'

export default {
  components: {
    draggable,
    vueCustomScrollbar
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      ficheData: null,
      client: [],
      projet: [],
      settings: {
        maxScrollbarLength: 60
      }
    }
  },
  methods: {
    cloneDog ({ id }) {
      // return {
      //   id: id,
      //   name: id
      // };
    }
  },
  created () {
    eventBus.$on('myDeleted', (data) => {
      if (data) {
        if (data[0] === 'P') {
          if (data === 'P01') {
            this.projet.push({
              key: 'P01',
              titre: 'Dénomination',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'P02') {
            this.projet.push({
              key: 'P02',
              titre: 'Type(s) d\'équipement(s)',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'P03') {
            this.projet.push({
              key: 'P03',
              titre: 'Numéro d\'affaire',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'P04') {
            this.projet.push({
              key: 'P04',
              titre: 'Nom du contact',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'P05') {
            this.projet.push({
              key: 'P05',
              titre: 'Email du contact',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'P06') {
            this.projet.push({
              key: 'P06',
              titre: 'Téléphone',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'P07') {
            this.projet.push({
              key: 'P07',
              titre: 'Mobile',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'P08') {
            this.projet.push({
              key: 'P08',
              titre: 'Adresse',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'P09') {
            this.projet.push({
              key: 'P09',
              titre: 'Complément d\'adresse',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'P10') {
            this.projet.push({
              key: 'P10',
              titre: 'Code Postal',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'P11') {
            this.projet.push({
              key: 'P11',
              titre: 'Ville',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'P12') {
            this.projet.push({
              key: 'P12',
              titre: 'Type d\'opération',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }
        }

        if (data[0] === 'C') {
          if (data === 'C56') {
            this.client.push({
              key: 'C56',
              titre: 'Type',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'C57') {
            this.client.push({
              key: 'C57',
              titre: 'Nom',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'C58') {
            this.client.push({
              key: 'C58',
              titre: 'Adresse',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'C59') {
            this.client.push({
              key: 'C59',
              titre: 'Complément d\'adresse',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'C60') {
            this.client.push({
              key: 'C60',
              titre: 'Code postal',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'C61') {
            this.client.push({
              key: 'C61',
              titre: 'Ville',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'C62') {
            this.client.push({
              key: 'C62',
              titre: 'Pays',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'C63') {
            this.client.push({
              key: 'C63',
              titre: 'Nom du contact',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'C64') {
            this.client.push({
              key: 'C64',
              titre: 'Prénom du contact',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'C65') {
            this.client.push({
              key: 'C65',
              titre: 'Téléphone',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'C66') {
            this.client.push({
              key: 'C66',
              titre: 'Mobile',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'C67') {
            this.client.push({
              key: 'C67',
              titre: 'Email 1',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }

          if (data === 'C68') {
            this.client.push({
              key: 'C68',
              titre: 'Email 2',
              colStyle: {},
              valStyle: {},
              style: {}
            })
          }
        }
      }
    })

    this.projet = [
      {
        key: 'P01',
        titre: 'Dénomination',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'P02',
        titre: 'Type(s) d\'équipement(s)',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'P03',
        titre: 'Numéro d\'affaire',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'P04',
        titre: 'Nom du contact',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'P05',
        titre: 'Email du contact',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'P06',
        titre: 'Téléphone',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'P07',
        titre: 'Mobile',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'P08',
        titre: 'Adresse',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'P09',
        titre: 'Complément d\'adresse',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'P10',
        titre: 'Code Postal',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'P11',
        titre: 'Ville',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'P12',
        titre: 'Type d\'opération',
        colStyle: {},
        valStyle: {},
        style: {}
      }
    ]

    this.client = [
      {
        key: 'C56',
        titre: 'Type',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'C57',
        titre: 'Nom',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'C58',
        titre: 'Adresse',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'C59',
        titre: 'Complément d\'adresse',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'C60',
        titre: 'Code postal',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'C61',
        titre: 'Ville',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'C62',
        titre: 'Pays',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'C63',
        titre: 'Nom du contact',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'C64',
        titre: 'Prénom du contact',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'C65',
        titre: 'Téléphone',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'C66',
        titre: 'Mobile',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'C67',
        titre: 'Email 1',
        colStyle: {},
        valStyle: {},
        style: {}
      },
      {
        key: 'C68',
        titre: 'Email 2',
        colStyle: {},
        valStyle: {},
        style: {}
      }
    ]
    this.ficheData = this.data
    this.ficheData.listColonne.push(this.client)
  },
  watch: {
    data (newValue, oldValue) {
      this.ficheData = newValue
    }
  }

}
</script>

<style lang="scss" scoped>
  .tab-0 {

    border: 1px solid #2b3085;
    border-top:none;
    padding-top:5px;
  }
  #list-tableau-colonne,
  .list-tableau-colonne-0{
    margin-bottom: 20px;
    font-family: "Noto Sans";
    border-radius: 3px;
    h2{
      color: #fff;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      background-color: #2b3085;
      padding-top: 3px;
      height: 25px;
      margin-bottom: 0;
      /*border-radius: 0 0 3px 3px;*/
    }
    p{
      color: #2b3085;
      font-size: 12px;
      padding-left: 25px;
      padding-right: 5px;
      position: relative;
      margin-bottom: 10px;
      svg{
        vertical-align: inherit;
        position: absolute;
        left: 5px;
      }
    }
    .list-group-item{
      border-radius: 0;
      border: none;
      border-top: 1px solid #2b3085;
      font-size: 13px;
      color: #2b3085;
      padding: 5px 25px;
      cursor: grab;
    }

    .scroll-area {
      height: calc(100vh - 250px);
      padding-right: 15px;
    }
    .ps__thumb-x, .ps__thumb-y {
      background-color: #2b3085 !important;
      width: 6px !important;
      right: 0;
      &:hover {
        background-color: #2b3085;
        width: 6px;
      }
    }
    .ps__rail-y {
      display: block;
      width: 8px;
      border: 1px solid #2b3085;
      border-radius: 6px;
    }

  }

  .list-tableau-colonne-0 .scroll-area {
    height: 390px;
    padding-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/edit/listTableauColonne.vue